<template>
  <div>
    <Title :pages="[{ icon: 'arrow-right', page: page_title.toUpperCase() }]"></Title>
    <v-container fluid>
      <!-- v-if="create_access" -->

      <v-card class="mb-4">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>
              <div class="row pt-2">
                <div class="col-md-3">
                  <v-text-field v-model="filters.date_from" density="comfortable" type="date" name="date_from" label="Desde" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.date_to" density="comfortable" type="date" name="date_to" label="hasta" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.almacen"
                    density="comfortable"
                    name="almacen"
                    item-title="name"
                    item-value="id"
                    :items="almacenes"
                    label="Almacen"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>
                <!-- <div class="col-md-3">
                    <v-text-field v-model="filters.state" density="comfortable"
                      name="state" label="Estado" :disabled="disabled"></v-text-field>
                  </div> -->

                <div class="col-md-3">
                  <v-text-field v-model="filters.code" density="comfortable" name="code" label="Orden de envio" :disabled="disabled"></v-text-field>
                </div>

                <div class="col-md-3">
                  <v-text-field v-model="filters.id" density="comfortable" label="Numero de ola" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-9 pt-2" style="display: flex; justify-content: end">
                  <v-btn color="info" class="" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card>
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col>
              <span>{{ page_title }}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <!-- v-if="list_access" -->

        <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando..." class="expandable-rows">
          <template v-slot:item="{ item }">
            <tr @click="toggleExpand(item.id)">
              <td class="expand-icon">
                <v-icon>{{ expandedRows.includes(item.id) ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
              </td>
              <td>{{ item.id }}</td>
              <td>{{ item.creation_date }}</td>
              <td>{{ item.almacen.name }}</td>

              <td>{{ item.status.name }}</td>
              <td>{{ item.description }}</td>

              <td class="text-center" style="min-width: 170px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="green" class="mr-2" v-on:click="assignDock(item)" size="small"> mdi-truck </v-icon>
                  </template>
                  <span>Reasignar muelle</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="violet" class="mr-2" v-on:click="createPickingDetail(item)" size="small"> mdi-package </v-icon>
                  </template>
                  <span>Preparar envios</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="delete_access" v-bind="props" small color="black" class="mr-2" v-on:click="cancelReserve(item)" size="small">mdi-close </v-icon>
                  </template>
                  <span>Cancelar Reservas</span>
                </v-tooltip>
              </td>
            </tr>
            <tr v-if="expandedRows.includes(item.id)">
              <td colspan="7" class="pl-0 pr-0">
                <v-data-table class="custom-subtable" :headers="shipmentHeaders" :items="item.shipment_orders" hide-default-footer disable-pagination style="background-color: #ccc">
                  <template v-slot:shipment="{ shipment }">
                    <tr>
                      <td>{{ shipment.code }}</td>
                      <td>{{ shipment.client.name }}</td>
                      <td>{{ shipment.almacen.name }}</td>
                      <td>{{ shipment.dock ? shipment.dock.name : "" }}</td>
                      <td>{{ shipment.receiver }}</td>
                      <td>{{ shipment.address }}</td>
                      <td>{{ shipment.location }}</td>
                      <td>{{ shipment.status.name }}</td>
                      <td>{{ shipment.sub_status.name }}</td>
                      <td class="text-center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" small color="red" class="mr-2" v-on:click="deleteItem(shipment)" size="small">mdi-delete </v-icon>
                          </template>
                          <span>Eliminar de la ola</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteFromWave" :loading="loadingSubmit" />

    <DialogYesNo
      :loading="loading_cancel"
      :open="dialog_cancel"
      title="Cancelar Reservas"
      message="¿Estas seguro que desea cancelar las reservas de los envios?"
      @cancel="
        dialog_cancel = false;
        wave_selected = null;
      "
      @accept="cancelReserveConfirm"
    />

    <ModalAssignMuelle
      :loading="loading_dock_assign"
      :dialog="dialog_dock_assign"
      title="Asignar muelle"
      button_accept="Confirmar"
      @updateDialog="
        dialog_dock_assign = false;
        wave_selected = null;
      "
      @assignMuelle="assignDockConfirm"
    />

    <ModalReservarOla
      :loading="loading_picking_detail"
      :dialog="dialog_picking_detail"
      title="Preparar Ola"
      button_accept="Preparar"
      @updateDialog="
        dialog_picking_detail = false;
        wave_selected = null;
        defaultDock_selected = null;
      "
      @createPickingDetail="confirmPickDetail"
      :defaultDock="defaultDock_selected"
    />
  </div>
</template>

<script>
import { waveService } from "@/libs/ws/waveService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import { shipmentOrderService } from "@/libs/ws/shipmentOrderService";
import { almacenService } from "@/libs/ws/almacenService";
import DialogYesNo from "@/components/DialogYesNo.vue";
import ModalAssignMuelle from "./ModalAssignMuelleOla.vue";
import ModalReservarOla from "./ModalReservarOla.vue";

import { docksService } from "@/libs/ws/docksService";

export default {
  components: { DialogDelete, DialogYesNo, ModalAssignMuelle, ModalReservarOla },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      service: waveService,
      shipmentOrderService: shipmentOrderService,
      page_title: "Olas de preparacion",
      modal_title: "Ola de preparacion",
      list: [],
      expandedRows: [],
      headers: [
        {},
        {
          title: "Numero",
          align: "left",
          sortable: true,
          key: "id",
        },
        {
          title: "Fecha",
          align: "left",
          sortable: true,
          key: "creation_date",
        },

        {
          title: "Almacen",
          align: "left",
          sortable: true,
          key: "almacen.name",
        },
        {
          title: "Estado",
          align: "left",
          sortable: true,
          key: "status",
        },
        {
          title: "Descripcion",
          align: "left",
          sortable: true,
          key: "description",
        },
        { title: "Accion", align: "center", sortable: false, key: "" },
      ],
      shipmentHeaders: [
        { title: "Codigo", key: "code", sortable: true, align: "left" },
        { title: "Cliente", key: "client.name", sortable: true, align: "left" },
        { title: "Almacen", key: "almacen.name", sortable: true, align: "left" },
        { title: "Muelle", key: "dock.name", sortable: true, align: "left" },
        { title: "Receptor", key: "receiver", sortable: true, align: "left" },
        { title: "Direccion", key: "address", sortable: true, align: "left" },
        { title: "Localidad", key: "location", sortable: true, align: "left" },
        { title: "Estado", key: "status.name", sortable: true, align: "left" },
        { title: "Sub estado", key: "sub_status.name", sortable: true, align: "left" },
        { title: "Accion", align: "center", sortable: false, key: "" },
      ],
      filters: {
        date_from: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        date_to: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        code: "",
        almacen: null,
        id: null,
      },
      almacenes: [],
      wave_selected: null,

      loading_picking_detail: false,
      loading_cancel: false,

      dialog_picking_detail: false,
      dialog_cancel: false,

      dialog_dock_assign: false,
      loading_dock_assign: false,
    };
  },
  mounted() {
    this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));

    this.loadList(this.service);
    this.loadAlmacenes();
  },
  methods: {
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    toggleExpand(id) {
      if (this.expandedRows.includes(id)) {
        this.expandedRows = this.expandedRows.filter((rowId) => rowId !== id);
      } else {
        this.expandedRows.push(id);
      }
    },
    getFilterParams() {
      // La tabla pagina del lado del cliente: se pide el listado completo
      return { ...this.filters, limit: 0 };
    },
    filter() {
      this.loadList(this.service);
    },
    deleteFromWave() {
      this.loadingSubmit = true;
      this.shipmentOrderService
        .delete_wave({ shipment_order: this.deleteId })
        .then((response) => {
          if (response.status === true) {
            this.toast.success(response.msg);
            this.loadList(this.service);
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.toast.error(response.message);
            } else {
              this.toast.error(response.msg);
            }
          }
        })
        .catch((e) => {
          this.toast.error("Error exception");
        })
        .finally(() => {
          this.dialog_delete = false;
          this.loadingSubmit = false;
        });
    },
    assignDock(item) {
      this.dialog_dock_assign = true;
      this.wave_selected = item;
    },
    assignDockConfirm(item) {
      if (this.loading_dock_assign) return;

      if (this.wave_selected == null) {
        this.toast.error("No se ha seleccionado ninguna ola.");
        return;
      }
      const data = {
        wave_id: this.wave_selected.id,
        dock: item,
      };

      this.loading_dock_assign = true;
      this.service
        .assignDock(data)
        .then((response) => {
          console.log(response);
          if (response.status === true) {
            this.toast.success(response.msg, { dangerouslyHTMLString: true });
            this.dialog_dock_assign = false;
            this.wave_selected = null;
            this.filter();
          } else {
            this.toast.error(response.msg, { dangerouslyHTMLString: true });
          }
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_dock_assign = false;
        });
    },
    createPickingDetail(item) {
      this.defaultDock_selected = item.shipment_orders[0].dock;
      this.wave_selected = item;
      this.dialog_picking_detail = true;
    },
    confirmPickDetail(item) {
      if (this.loading_picking_detail) return;

      if (this.wave_selected == null) {
        this.toast.error("No se ha seleccionado ninguna ola.");
        return;
      }

      if (item == null) {
        this.toast.error("No se ha seleccionado ningun muelle.");
        return;
      }

      const data = {
        wave_id: this.wave_selected.id,
        dock: item,
      };

      this.loading_picking_detail = true;
      console.log(data);
      shipmentOrderService
        .generatePickingDetail(data)
        .then((response) => {
          console.log(response);
          if (response.status === true) {
            this.toast.success(response.msg, { dangerouslyHTMLString: true });
            this.dialog_picking_detail = false;
            this.wave_selected = null;
            this.defaultDock_selected = null;
            this.filter();
          } else {
            this.toast.error(response.msg, { dangerouslyHTMLString: true });
          }
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_picking_detail = false;
        });
    },
    cancelReserve(item) {
      this.wave_selected = item;
      this.dialog_cancel = true;
    },
    cancelReserveConfirm(item) {
      if (this.loading_cancel) return;

      if (this.wave_selected == null) {
        this.toast.error("No se ha seleccionado ninguna ola.");
        return;
      }

      const data = {
        wave_id: this.wave_selected.id,
      };
      this.loading_cancel = true;
      shipmentOrderService
        .cancel_reserve(data)
        .then((response) => {
          if (response.status) {
            this.toast.success("La reserva de la ola de peparacion #" + this.wave_selected.id + " se cancelo correctamente.");
            this.dialog_cancel = false;
            this.wave_selected = [];
            this.filter();
          } else {
            this.toast.error(response.msg);
          }
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_cancel = false;
        });
    },
  },
};
</script>
<style scoped>
.expand-icon {
  width: 50px;
  text-align: center;
}

.sub-table {
  padding: 0;
}

.expandable-rows .v-data-table__wrapper {
  overflow: visible !important;
}
</style>
